import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "flex sm12 md6 lg4 mr-2 pb-3" }

import { ref } from "vue";
import {
  SubscriptionType,
  SubscriptionTypeStatus,
} from "@/models/SubscriptionType";
import EditCategory from "@/components/EditCategory.vue";
import { Protocol } from "@/models/Protocol";
import { fetchProtocol, protocolUpdate } from "@/composables/getProtocolByID";
import Moralis from "moralis";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  protocolID: { type: String, required: true },
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props


const selectedProtocol = ref<Protocol>(new Protocol());
selectedProtocol.value = (
  ([__temp,__restore] = _withAsyncContext(() => fetchProtocol(props.protocolID))),
  __temp = await __temp,
  __restore(),
  __temp
);

const subCategories = ref<SubscriptionType[]>([]);

const fetchsubCategories = async (): Promise<void> => {
  const q = new Moralis.Query(SubscriptionType);
  if (selectedProtocol.value) {
    q.equalTo("protocol", selectedProtocol.value);
    q.equalTo("status", SubscriptionTypeStatus.active);
    const res = await q.find();
    subCategories.value.length = 0;
    subCategories.value.push(...res);
  }
};

const updateCategoryName = async (): Promise<void> => {
  fetchsubCategories();
};
const updateCategoryDescription = async (): Promise<void> => {
  fetchsubCategories();
};
const addedCategory = async (): Promise<void> => {
  fetchsubCategories();
};
const deactivateCategory = async (): Promise<void> => {
  fetchsubCategories();
};

;(
  ([__temp,__restore] = _withAsyncContext(() => fetchsubCategories())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subCategories.value, (category) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "flex sm12 md6 lg4 mr-2 pb-3",
        key: category.id
      }, [
        _createVNode(EditCategory, {
          category: category,
          protocol: selectedProtocol.value,
          "onUpdate:name": updateCategoryName,
          "onUpdate:description": updateCategoryDescription,
          onDeactivated: deactivateCategory
        }, null, 8, ["category", "protocol"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(EditCategory, {
        protocol: selectedProtocol.value,
        onAdded: addedCategory
      }, null, 8, ["protocol"])
    ])
  ]))
}
}

})